import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { OrderCancellationPolicyAdminDto } from '@/backend/market'
import { OrderCancellationPolicyEntity } from '../../domain/entities/OrderCancellationPolicyEntity'

export class OrderCancellationPolicyModel extends OrderCancellationPolicyEntity {
  constructor(dataDto: OrderCancellationPolicyAdminDto) {
    super()
    mapEntityProperties<OrderCancellationPolicyEntity>(this, dataDto)
  }
}
